import React from 'react'
import { Button } from '@material-ui/core'
import { getFormValues, reset } from 'redux-form'
import { toast } from 'react-toastify'
import { COLORES } from '../../../config/colores'
import { MESES } from '../../../config/meses'
import { COLUMNS } from './constantesBuquesAnunciados'
import Buque from '../../../models/buque/buque'
import Giro from '../../../models/giro/giro'
import ComunicacionEmbarque from '../../../models/comunicacionEmbarque/comunicacionEmbarque'
import PlanDeEmbarque from '../../../models/embarque/plan_de_embarque'
import { LineUpBuques } from '../../../models/buque/line_up_buques'
import { TABLA_LINE_UP_BUQUES } from '../../../config/tables'
import { FORM_LINE_UP_BUQUES } from '../../../config/forms'
import AnunciarBuqueDialog from '../components/anunciobuques/AnunciarBuqueDialog'
import DialogoAnuncioBuqueUpdate from '../components/anunciobuques/DialogoAnuncioBuqueUpdate'
import { openAgregarBuqueDialog } from '../actions/TablaBuquesActions'
import { actualizarDatosCargaBuques } from './TablaCargaBuquesActions'
import moment from 'moment'
import { CargaBuque } from '../../../models/buque/carga_buque'

export function updateBuqueAnunciado () {
  return (dispatch) => {
    dispatch(actualizarDatosParaMuiTable())
  }
}

export function agregarBuqueDialog () {
  return openAgregarBuqueDialog()
}

// export function getDataBuquePorNombre (nombreCompleto) {
//   const partial = (nombreCompleto).split('-')
//   const nombre = partial[0].trim()
//   return Buque.getDatosBuquePorNombre(nombre)
//     .then((data) => {
//       return data
//     })
//     .catch((error) => {
//       console.log(error)
//       return null
//     })
// }

export async function parseData (data) {
  const parsedData = []
  for (const entry of data) {
    const dataBuque = {
      imo: entry.imo,
      mmsi: entry.mmsi
    }

    let vigente = false
    // Se toma como parametro la última (puede ser igual a desde o mayor)
    let fechaEstimada = (entry.fechaEstimadaDeArriboDesde).split(' ')
    fechaEstimada = fechaEstimada[0].split('-')
    var dEstimado = fechaEstimada[2]
    var mEstimado = fechaEstimada[1] < 10 ? parseInt('0' + fechaEstimada[1]) : fechaEstimada[1]
    var yEstimado = fechaEstimada[0]

    var fechaActual = new Date()
    var dActual = fechaActual.getDate()
    var mActual = fechaActual.getMonth() + 1
    var yActual = fechaActual.getFullYear()

    if (yEstimado >= yActual) {
      if (mEstimado > mActual) {
        vigente = true
      } else if (mEstimado === mActual) {
        if (dEstimado >= dActual) {
          vigente = true
        }
      }
    }

    // Se extrae mes de fecha para filtrar por mes en la tabla
    const mes = new Date(entry.fechaEstimadaDeArriboDesde).getMonth() + 1

    const nombreBuque = {
      nombreCorto: entry.nombreCorto,
      nombre: entry.nombre
    }

    const fechaEstimadaDeArribo = {
      fechaDesde: entry.fechaEstimadaDeArriboDesde || null,
      fechaHasta: entry.fechaEstimadaDeArriboHasta || null,
      estado: entry.estado,
      vigente: vigente
    }

    parsedData.push({ ...entry, dataBuque, nombreBuque, fechaEstimadaDeArribo, mesIndex: MESES[mes], anuncio: entry })
  }

  return parsedData
}

export function getAnuncioBuquePorFecha (fecha) {
  return (dispatch, callback) => {
    dispatch({ type: 'RESET_ANUNCIO_BUQUE' })
    return LineUpBuques.getAnuncioPorFecha(fecha)
      .then((anuncio) => {
        dispatch({ type: 'RECEIVE_ANUNCIO_BUQUE', anuncio })
        callback && callback(anuncio)
      })
      .catch(() => {
        dispatch({ type: 'RECEIVE_ANUNCIO_BUQUE', anuncio: null })
      })
  }
}
export function resetAnuncioInicial () {
  return (dispatch) => {
    dispatch({ type: 'RESET_ANUNCIO_BUQUE' })
  }
}

export function updateAnuncioBuques (fecha) {
  return async (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_LINE_UP_BUQUES)(state)

    if (!formValues) {
      toast.error('Error al intentar editar el anuncio')
      dispatch(reset(FORM_LINE_UP_BUQUES))
      return
    }

    if (formValues.nombre) {
      const nombreCompleto = formValues.nombre
      let expresionRegular = nombreCompleto.match(/\((.*?)\)/)
      if ((!formValues.nombreCorto && !formValues.nombreCortoInicial) || (expresionRegular)) {
        expresionRegular = expresionRegular[1].split('[')
        const nombreCorto = expresionRegular ? expresionRegular[0] : null
        formValues.nombreCorto = nombreCorto.trim()
      }
    } else {
      formValues.nombreCorto = null
    }

    if (formValues.agencia) {
      const partial = (formValues.agencia).split('-')
      const cuitAgencia = partial[1].trim()
      formValues.agencia = cuitAgencia
    }

    if (formValues.agenciaDeEstiba) {
      const partial = (formValues.agenciaDeEstiba).split('-')
      const cuitAgencia = partial[1].trim()
      formValues.agenciaDeEstiba = cuitAgencia
    }

    try {
      // Primero se  actualiza el anuncio del buque
      const [result, fechaAnuncioActualizada] = await LineUpBuques.updateAnuncioBuque(fecha, formValues)

      if (result.error) {
        toast.error('Error al actualizar el anuncio del buque.')
        return
      }

      // Cuando el buque ya tiene plan de embarque
      if (formValues.fechaPlanDeEmbarque) {
        const fechaPlanEmbarque = formValues.fechaPlanDeEmbarque
        const newBuque = formValues.nombreCorto
        const oldBuque = formValues.nombreCortoInicial
        const agencia = formValues.agencia
        await PlanDeEmbarque.updatePlanDeEmbarque(fechaPlanEmbarque, newBuque, oldBuque, agencia)
      }

      // Se calcula diferencia en días entre las fechas de posible arribo -desde-
      const oldDate = moment(formValues.fechaDeArriboDesdeOld, 'DD/MM/YYYY')
      const newDate = moment(formValues.fechaDeArriboDesde, 'DD/MM/YYYY')
      const diferenciaEnDias = newDate.diff(oldDate, 'days')

      // Si hay diferencia entre las fechas, actualiza las cargas
      CargaBuque.obtenerDetalleCarga(fechaAnuncioActualizada)
        .then(async (data) => {
          if (!data || data.length === 0) {
            return
          }

          let cargas = data
          // Si la diferencia en dias es positiva, se invierten los registros
          // para evitar conflictos con la PK.
          if (diferenciaEnDias > 0) {
            cargas = [...data].reverse()
          }

          // Promesa para actualizar las fechas de carga segun diferencia en dias
          const createPromises = cargas.map(d => {
            const fechaBase = moment(d.fechaDeCarga, 'YYYY-MM-DD')
            const nuevaFecha = fechaBase.add(diferenciaEnDias, 'days').format('YYYY-MM-DD')

            const values = {
              fechaAnuncio: fechaAnuncioActualizada,
              fechaCarga: nuevaFecha,
              cuitExportador: d.exportador,
              cereal: d.claveCereal,
              toneladas: d.toneladas
            }

            return CargaBuque.updateDetalleCarga(values, fechaAnuncioActualizada, d.fechaDeCarga, d.exportador, d.claveCereal)
          })

          await Promise.all(createPromises)

          dispatch({ type: 'EDICION_ANUNCIO_BUQUE' })
          dispatch(actualizarDatosCargaBuques())
          dispatch(actualizarDatosParaMuiTable())
          toast.success('Anuncio de buque editado correctamente.')
        })
    } catch (error) {
      console.error(error)
      toast.error('Error al intentar editar el anuncio.')
    }
  }
}

export function saveFechaReferenciaPlanDeEmbarque (fecha, fechaDeReferencia = null) {
  return LineUpBuques.updateFechaPlanDeEmbarque(fecha, fechaDeReferencia)
}

export function cancelarAnuncioDeBuque (fecha) {
  return (dispatch) => {
    return LineUpBuques.cancelarAnuncioBuque(fecha, 'CANCELAD')
      .then((response) => {
        dispatch({ type: 'CANCELAR_ANUNCIO_BUQUE' })
        toast.success('Anuncio de buque cancelado correctamente')
        dispatch(actualizarDatosParaMuiTable())
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al intentar cancelar el anuncio')
      })
  }
}

export function deleteAnuncioDeBuque (fecha) {
  return (dispatch) => {
    return LineUpBuques.deleteAnuncioBuque(fecha)
      .then((response) => {
        dispatch({ type: 'ELIMINAR_ANUNCIO_BUQUE' })
        toast.success('Anuncio de buque eliminado correctamente')
        dispatch(actualizarDatosParaMuiTable())
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al intentar eliminar el anuncio')
      })
  }
}

export function submitNuevoAnuncioBuque () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_LINE_UP_BUQUES)(state)

    if (!formValues) {
      toast.error('Error al intentar anunciar un buque')
      dispatch(reset(FORM_LINE_UP_BUQUES))
      return
    }

    const nombreCompleto = formValues.nombre
    if (nombreCompleto) {
      let expresionRegular = nombreCompleto.match(/\((.*?)\)/)
      expresionRegular = expresionRegular[1].split('[')
      const nombreCorto = expresionRegular ? expresionRegular[0] : null
      formValues.nombreCorto = nombreCorto.trim()
    }

    if (formValues.agencia) {
      const partial = (formValues.agencia).split('-')
      const cuitAgencia = partial[1].trim()
      formValues.agencia = cuitAgencia
    }

    if (formValues.agenciaDeEstiba) {
      const partial = (formValues.agenciaDeEstiba).split('-')
      const cuitAgencia = partial[1].trim()
      formValues.agenciaDeEstiba = cuitAgencia
    }

    return LineUpBuques.insertarAnuncioBuque(formValues)
      .then((result) => {
        if (!result.error) {
          dispatch({ type: 'ANUNCIAR_BUQUE' })
          toast.success('Buque anunciado correctamente')
          dispatch(actualizarDatosParaMuiTable())

          // Agregar Caratula
          if (formValues.nombreCorto !== undefined && formValues.nombreCorto !== null) {
            const caratulaValues = {
              fechaArribo: formValues.fechaDeArriboDesde,
              fechaZarpada: formValues.fechaDeArriboHasta,
              buque: {
                nombreCorto: formValues.nombreCorto
              },
              exportador: formValues.exportador,
              agencia: formValues.agencia,
              giro: formValues.giro,
              buqueAceitero: false,
              cereal: formValues.claveCereal
            }
            ComunicacionEmbarque.altaCaratula(caratulaValues)
              .then((saveStatus) => {
                if (!saveStatus.error) {
                  toast.success('Carátula ingresada exitosamente.')
                } else {
                  toast.error('Error al ingresar la Carátula.')
                }
              })
          }
        }
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al intentar anunciar buque')
      })
    // } else {
    //   toast.error(`Error al intentar anunciar un buque. El buque  ${formValues.nombreCorto} ya se encuentra anunciado`)
    // }
  }
}

export function openAnunciarBuqueDialog () {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      submitNuevoAnuncioBuque()(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ANUNCIAR_BUQUE'
      })
      dispatch({ type: 'RESET_ENTITY' })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'ANUNCIAR_BUQUE'
      })
      dispatch({ type: 'RESET_ENTITY' })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'ANUNCIAR_BUQUE',
      maxWidth: 'md',
      content: <AnunciarBuqueDialog
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
      />
    })
    dispatch({
      type: 'OPEN_ANUNCIO_BUQUE'
    })
  }
}

export function openEdicionAnuncioBuqueDialog (fecha) {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      updateAnuncioBuques(fecha)(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'EDICION_ANUNCIO_BUQUE'
      })
      dispatch({ type: 'RESET_ENTITY' })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'EDICION_ANUNCIO_BUQUE'
      })
      dispatch({ type: 'RESET_ENTITY' })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'EDICION_ANUNCIO_BUQUE',
      maxWidth: 'md',
      content: <DialogoAnuncioBuqueUpdate
        confirmCallback={confirmCallback}
        cancelCallback={cancelCallback}
        fechaAnuncio={fecha}
      />
    })
    dispatch({
      type: 'OPEN_ANUNCIO_BUQUE'
    })
  }
}

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_LINE_UP_BUQUES
    })
    LineUpBuques.getBuquesAnunciados().then(callback)
    async function callback (d) {
      const data = await parseData(d)

      const customToolbar = () => (
        <div className='container-btn-toolbar btn-toolbar'>
          <Button
            variant='contained'
            style={{ color: COLORES.blue.primary, width: '100%', fontWeight: 'bold' }}
            size='small'
            onClick={() => { dispatch(openAnunciarBuqueDialog()) }}
          >
            ANUNCIAR BUQUE
          </Button>
        </div>
      )

      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS,
          data: data,
          title: 'Line Up Buques',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false, pagination: false, monthFilter: true }
        },
        id: TABLA_LINE_UP_BUQUES
      })
    }
  }
}

export function getGiros (callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_GIROS' })
    Giro.getGiros()
      .then(giros => {
        dispatch({ type: 'RECEIVE_GIROS', giros })
        callback && callback(giros)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_GIROS',
        giros: null
      }))
  }
}

export function getEstados (callback) {
  return dispatch => {
    dispatch({ type: 'REQUEST_ESTADOS' })
    Buque.getEstadosBuque()
      .then(estados => {
        dispatch({ type: 'RECEIVE_ESTADOS', estados })
        callback && callback(estados)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_ESTADOS',
        estados: null
      }))
  }
}

export function actualizarFechaDeCargaBuque (fecha, fechaDesde, fechaHasta) {
  return (dispatch) => {
    dispatch({ type: 'UPDATE_FECHA_CARGA_BUQUE' })
    LineUpBuques.updateFechaDeCarga(fecha, fechaDesde, fechaHasta)
      .then((result) => {
        if (!result.error) {
          dispatch(actualizarDatosParaMuiTable())
        } else {
          toast.error('Error al intentar actualizar las fechas de carga del buque')
        }
      })
      .catch((error) => {
        console.log(error)
        toast.error('Error al intentar actualizar las fechas de carga del buque')
      })
  }
}
